import React from "react";
import { Flex, Box, Heading, Text } from "rebass";
import { ULink } from "../components/ULink";

interface IProps {
  number: string;
  title: string;
  tagline: string;
  to?: string | undefined;
  page: string;
  url: string;
  discipline: string; 
  year: string;
  id: string;
  index: number;
  label: string | undefined;
}
const Project = (props: IProps) => {
  return (
    <Box variant="projectCard" width={[1 / 1, 1 / 1, 1 / 3]} mt={[0,0,0,5]}> 
      <ULink
        {...props}
        to={props.page}
        activeClassName="active"
        sx={{
          variant: "links.imgLink",
          display: "block"
        }}
      >

        {/* <img src={props.url} alt={props.title} /> */}
        <Text as="p" variant="catHeading" pb={[0,0,0]} mt={[0,0,0]} mb={[2,2,2,2]}>Case {props.number}</Text>
        <Flex
          flexWrap="wrap"
          justifyContent="start"
        >  
          <Box>
            <Heading as="h2" fontFamily="display" fontSize={[7]} mb={[1,1,1,2]}>
              {props.title}
            </Heading>
          </Box>
          {props.label ?
            <Box>
             <Text as="span" variant="projectLabel">{props.label}</Text>
            </Box>
            :
            null
          }  
        </Flex>       
        {/* <Text as="span">{props.discipline}</Text> */}
        <Text as="p" maxWidth="44rem" sx={{ display:["none","none","none", "block","block"]}}>{props.tagline}</Text>
      </ULink>
    </Box>
  );
};

export default Project;
